import React from "react";
import { fetchSession } from "api/webservice/sessions";
import { Session } from "types";
/* import Room from "./Room"; */
import { Box, Text } from "@chakra-ui/react";
import { Card } from "components";
import AudioSettingsPanel from "./AudioSettingsPanel";

interface Props {
  sessionId?: string;
  componentHeight: number;
  toggleGameLiftStreamsInput: any;
}

//note: device selector and audio level indicator are here as placeholders, may remove/update on future commits
const VoiceMorph: React.FC<Props> = ({sessionId, componentHeight, toggleGameLiftStreamsInput}: Props) => {
  return (
    <Card height={componentHeight} onClick={() => toggleGameLiftStreamsInput(false)}>
      <Box>
        <Text fontSize="20px" fontWeight="600">
          Audio Settings
        </Text>
      </Box>
      <AudioSettingsPanel/>
    </Card>
  );
};

export default VoiceMorph;